<template>
    <div>
        <PageDrawer
            :value.sync="visible"
            :title="dialogTitle"
            width="640px"
            @confirm="handleSubmit"
            :confirm-loading="saving"
            @close="resetForm">
            <div>
                <el-form ref="form" :model="form" :rules="rules" label-position="top" size="small">
                    <el-form-item label="旧密码" prop="oldPassword">
                        <el-input 
                            v-model="form.oldPassword" 
                            :type="showOldPassword ? 'text' : 'password'" 
                            placeholder="请输入旧密码">
                            <template #suffix>
                                <i 
                                    :class="showOldPassword ? 'el-icon-view' : 'el-icon-view'" 
                                    @click="showOldPassword = !showOldPassword"
                                    :style="showOldPassword ? 'cursor: pointer; color: #409EFF; font-size: 18px; display: flex; align-items: center; justify-content: center;' : 'cursor: pointer; color: #909399; position: relative; font-size: 18px; display: flex; align-items: center; justify-content: center;'">
                                    <span v-if="!showOldPassword" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg); width: 100%; height: 2px; background-color: #909399; display: block;"></span>
                                </i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input 
                            v-model="form.newPassword" 
                            :type="showNewPassword ? 'text' : 'password'" 
                            placeholder="请输入新密码">
                            <template #suffix>
                                <i 
                                    :class="showNewPassword ? 'el-icon-view' : 'el-icon-view'" 
                                    @click="showNewPassword = !showNewPassword"
                                    :style="showNewPassword ? 'cursor: pointer; color: #409EFF; font-size: 18px; display: flex; align-items: center; justify-content: center;' : 'cursor: pointer; color: #909399; position: relative; font-size: 18px; display: flex; align-items: center; justify-content: center;'">
                                    <span v-if="!showNewPassword" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg); width: 100%; height: 2px; background-color: #909399; display: block;"></span>
                                </i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input 
                            v-model="form.confirmPassword" 
                            :type="showConfirmPassword ? 'text' : 'password'" 
                            placeholder="请输入确认密码">
                            <template #suffix>
                                <i 
                                    :class="showConfirmPassword ? 'el-icon-view' : 'el-icon-view'" 
                                    @click="showConfirmPassword = !showConfirmPassword"
                                    :style="showConfirmPassword ? 'cursor: pointer; color: #409EFF; font-size: 18px; display: flex; align-items: center; justify-content: center;' : 'cursor: pointer; color: #909399; position: relative; font-size: 18px; display: flex; align-items: center; justify-content: center;'">
                                    <span v-if="!showConfirmPassword" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg); width: 100%; height: 2px; background-color: #909399; display: block;"></span>
                                </i>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </PageDrawer>
    </div>
</template>
<script>
import PageDrawer from '@/components/common/PageDrawer.vue'
import { userApi } from '@/api'
export default {
    name: 'ModifyPassword',
    components: {
        PageDrawer
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogTitle: '修改密码',
            saving: false,
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            rules: {
                oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'submit' }],
                newPassword: [{ required: true, message: '请输入新密码', trigger: 'submit' }],
                confirmPassword: [
                    { required: true, message: '请输入确认密码', trigger: 'submit' },
                    { validator: this.confirmPasswordValidator, trigger: 'submit' }
                ]
            },
            form: {
                oldPassword: '',
                newPassword: '',    
                confirmPassword: ''
            }
        }
    },
    methods: {
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saving = true
                    userApi.modifyPassword(this.form).then((res) => {
                        if (res && res.code === 200) {
                            this.$message.success('修改密码成功')
                            this.$emit('update:visible', false)
                            this.resetForm()
                        }     
                    }).catch((error) => {
                    }).finally(() => {
                        this.saving = false
                    })
                }
            })
        },
        resetForm() {
            this.form = {
                oldPassword: '',
                newPassword: '',    
                confirmPassword: ''
            }
            this.showOldPassword = false
            this.showNewPassword = false
            this.showConfirmPassword = false
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.$emit('update:visible', false)
        },
        confirmPasswordValidator(rule, value, callback) {
            if (value !== this.form.newPassword) {
                callback(new Error('确认密码与新密码不一致'))
            } else {
                callback()
            }
        }
    }
}
</script>

<style scoped>
/* 强制覆盖 Element UI 输入框后缀图标的样式 */
.el-input__suffix {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.el-input__suffix i {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  width: 100% !important;
}

/* 确保图标在输入框内垂直居中 */
.el-input__suffix-inner {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
}
</style>